<template>
  <div >
    <el-dialog  title="新增司机" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"
    :visible="addDriverFlag" width="1200px" center  append-to-body>
      <div>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="180px" size="mini" v-if="addDriverFlag">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder=""  @blur="CPHfn()"   maxlength="18" v-model.trim="addFrom.identityNo"></el-input>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder=""  maxlength="11" v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.mobile"></el-input>
              </el-form-item>
               <!-- <el-form-item label="司机所属:" prop="driverClassify">
                <el-select placeholder="请选择" v-model="addFrom.driverClassify" @change="driverClassifyChange">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="所属单位/个人:"  prop="driverTenant" v-if="addFrom.driverClassify==1" key="1">
                <el-select placeholder="请选择"  filterable allow-create  remote reserve-keyword  :remote-method="remoteMethod"
                default-first-option v-model="addFrom.driverTenant" value-key="tenantCode" >
                  <el-option
                    v-for="(item,index) in ssdw"
                    :key="index"
                    :label="item.tenantName"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="所属单位/个人:" prop="driverTenantName" v-if="addFrom.driverClassify==2" key="2">
                <el-input  placeholder="" v-model="addFrom.driverTenantName"  maxlength="11"></el-input>
              </el-form-item> -->
              <el-form-item label="驾驶证号:" prop="licenseNum">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.licenseNum" ></el-input>
              </el-form-item>
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                <el-input  placeholder="" maxlength="50" v-model.trim="addFrom.certificateNum"></el-input>
              </el-form-item>
               <el-form-item label="身份证开始日期:" :rules="[{ required: isBitian, message: '请选择身份证开始日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.identityStratDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
               <el-form-item label="身份证是否长期:" prop="sfzcq " class="ziti" >
                  <template >
                    <div style="width:150px">
                       <el-radio-group v-model="addFrom.sfzcq">
                        <el-radio :label="1" >是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item label="身份证有效期:" prop="identityExpiringDate" v-if="addFrom.sfzcq==2">
                <el-date-picker
                  v-model="addFrom.identityExpiringDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
              <el-form-item label="道路运输从业资格证:"  prop="qualificationNum">
                  <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.qualificationNum"></el-input>
                </el-form-item>
              <el-form-item label="准驾车型:" filterable prop="quasiDrivingModelArr" >
                <el-select placeholder="请选择" multiple v-model="addFrom.quasiDrivingModelArr">
                  <el-option
                    v-for="(item,index) in zjcx"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="驾驶证发证机关:"  prop="issueAuthority">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.issueAuthority"></el-input>
              </el-form-item>
              <el-form-item label="驾照起始日期:" :rules="[{ required: isBitian, message: '请选择驾照起始日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.validPeriodFrom"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="驾照是否长期:" prop="jzcq " class="ziti"  >
                  <template >
                    <div style="width:150px">
                       <el-radio-group v-model="addFrom.jzcq">
                        <el-radio :label=1 >是</el-radio>
                        <el-radio :label=2>否</el-radio>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item label="驾照结束日期:" prop="validPeriodTo" v-if="addFrom.jzcq==2">
                <el-date-picker
                  v-model="addFrom.validPeriodTo"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
                 <el-form-item label="从业资格证生效日期:" :rules="[{ required: isBitian, message: '请选择从业资格证生效日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.qualificationLicenceStartDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="从业资格证失效日期:" :rules="[{ required: isBitian, message: '请选择从业资格证失效日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.qualificationLicenceEndDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
                <div style="display:flex;">
                  <el-form-item label="行政区域:" :class="{'diqu':true,'is-required':isBitian}" prop="xname" >
                    <shengShiXian :rowData="this.addFrom" @handleChange="handleChange" v-if="flag"></shengShiXian>
                  </el-form-item>
                  <el-form-item label="身份证地址:" class="diqu" prop="address" >
                    <el-input  placeholder=""  maxlength="100" v-model.trim="addFrom.address"></el-input>
                  </el-form-item>
                </div>
               <div class="box" v-if="newImgFlag&&isBitian">
                <div class="imgBox">
                    <uploadImg :img='img' key="0" @remove ='handleRemove'  @change ='imgPreview'></uploadImg>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img1'  key="1"  @remove ='handleRemove1'  @change ='imgPreview1'></uploadImg>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img2'  key="2"  @remove ='handleRemove2'  @change ='imgPreview2'></uploadImg>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img3' key="3"   @remove ='handleRemove3'  @change ='imgPreview3'></uploadImg>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img4' key="4"   @remove ='handleRemove4'  @change ='imgPreview4'></uploadImg>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>
        </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cDadd, getCDriverInfo, getDictionary } from '@/api/vgs-driver2.0'
import { selectTenantListByName } from '@/api/soc-customer'
import { compressImage } from '@/utils/compressImage'
import shengShiXian from '@/components/common/shengShiXian.vue'
import uploadImg from '@/components/uploadImg.vue'
export default {
  components: {
    uploadImg, shengShiXian
  },
  name: 'guanlianhetong',
  props: {
    addDriverFlag: {
      type: Boolean,
      default: false
    },
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      isAdd: true,
      loading: false,
      addFrom: { jzcq: 2, sfzcq: 2 },
      title: '新建司机信息',
      img: [],
      img1: [],
      img2: [],
      img3: [],
      img4: [],
      imgList: [],
      newImgFlag: false,
      flag: true,
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        xname: [
          { required: this.isBitian, message: '请选择省市县', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        account: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        licenseNum: [
          { required: this.isBitian, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        certificateNum: [
          { required: this.isBitian, message: '请输入驾驶证号档案号', trigger: 'blur' }
        ],
        qualificationNum: [
          { required: this.isBitian, message: '请输入从业资格证号', trigger: 'blur' }
        ],
        driverTenantName: [
          { required: this.isBitian, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        driverTenant: [
          { required: this.isBitian, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        quasiDrivingModelArr: [
          { required: true, message: '请选择准驾车型', trigger: 'blur' }
        ],
        issueAuthority: [
          { required: this.isBitian, message: '请输入驾驶证发证机关', trigger: 'blur' }
        ],
        identityExpiringDate: [
          { required: this.isBitian, message: '请选择身份证有效期', trigger: 'blur' }
        ],
        validPeriodFrom: [
          { required: this.isBitian, message: '请选择驾照起始日期', trigger: 'blur' }
        ],
        validPeriodTo: [
          { required: this.isBitian, message: '请选择驾照结束日期/个人', trigger: 'blur' }
        ],
        address: [
          { required: this.isBitian, message: '请输入身份证地址', trigger: 'blur' }
        ],
        qualificationLicenceStartDate: [
          { required: this.isBitian, message: '请选择从业资格证生效日期', trigger: 'blur' }
        ],
        qualificationLicenceEndDate: [
          { required: this.isBitian, message: '请选择从业资格证失效日期', trigger: ['blur', 'change'] }
        ]
      },
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      zjcx: ['A1', 'A2', 'A3', 'B1', 'B2', 'C1', 'C2', 'C3', 'C4', 'D', 'E'],
      total: 0,
      value2: '',
      ids: [],
      dialogVisible: false,
      kztzVisible: false,
      dialoglook: false,
      disabled: false,
      hideUploadEditA: false,
      hideUploadEditB: false,
      hideUploadEditC: false,
      hideUploadEditD: false,
      ssdw: [], // 所属单位列表
      recordVisible: false,
      activities: [],
      isBitian: false
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionary({ groupName: 'certificate_flag' }).then(res => {
      if (res) {
        this.isBitian = res.value1 == 1
      }
    })
  },
  methods: {
    // 所属单位
    remoteMethod (query) {
      console.log(222)
      if (query !== '') {
        selectTenantListByName({ tenantNameLike: query }).then(res => {
          this.ssdw = res
        })
      }
    },
    // 所属切换
    driverClassifyChange () {
      if (this.addFrom.driverClassify == 2) {
        this.$set(this.addFrom, 'driverTenantName', this.addFrom.name)
        this.$set(this.addFrom, 'driverTenantCode', '')
      }
    },
    // 获取司机信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.newImgFlag = false
        getCDriverInfo({ identityNo: this.addFrom.identityNo }).then(res => {
          loading.close()
          if (res.id) {
            this.addFrom = res
            if (this.addFrom.driverClassify == 1) {
              if (res.driverTenantCode == '') {
                this.$set(this.addFrom, 'driverTenant', res.driverTenantName)
              } else {
                this.$set(this.addFrom, 'driverTenant', { tenantCode: res.driverTenantCode, tenantName: res.driverTenantName })
              }
            }
            this.$set(this.addFrom, 'quasiDrivingModelArr', res.quasiDrivingModel.split(','))
            if (res.identityPhoto1Url) {
              this.$set(this.img, 0, { status: 'ready', url: res.identityPhoto1Url })
              this.$set(this.imgList, 0, 1)
            }
            if (res.identityPhoto2Url) {
              this.$set(this.img1, 0, { status: 'ready', url: res.identityPhoto2Url })
              this.$set(this.imgList, 1, 1)
            }
            if (res.appendix1Url) {
              this.$set(this.img2, 0, { status: 'ready', url: res.appendix1Url })
              this.$set(this.imgList, 2, 1)
            }
            if (res.appendix2Url) {
              this.$set(this.img3, 0, { status: 'ready', url: res.appendix2Url })
              this.$set(this.imgList, 3, 1)
            }
            if (res.qualificationPhotoUrl) {
              this.$set(this.img4, 0, { status: 'ready', url: res.qualificationPhotoUrl })
              this.$set(this.imgList, 4, 1)
            }
            this.newImgFlag = true
            this.isEdits = []
            res.cDriverBankCardList.forEach(item => {
              this.isEdits.push(false)
            })
          } else {
            let identityNo = this.addFrom.identityNo
            this.addFrom = {
              identityNo: identityNo
            }
            this.imgList = []
            this.img = []
            this.img1 = []
            this.img2 = []
            this.img3 = []
            this.img4 = []
            this.newImgFlag = true
          }
          this.$set(this.addFrom, 'licenseNum', this.addFrom.identityNo)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 添加保存
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.addFrom.driverClassify == 1) {
          //   if (typeof (this.addFrom.driverTenant) == 'string') {
          //     this.addFrom.driverTenantName = this.addFrom.driverTenant
          //     this.addFrom.driverTenantCode = ''
          //   } else {
          //     this.addFrom.driverTenantName = this.addFrom.driverTenant.tenantName
          //     this.addFrom.driverTenantCode = this.addFrom.driverTenant.tenantCode
          //   }
          // }
          this.addFrom.driverClassify = 1
          if (this.addFrom.sfzcq == 1) {
            this.addFrom.identityExpiringDate = '长期'
          }
          if (this.addFrom.jzcq == 1) {
            this.addFrom.validPeriodTo = '长期'
          }
          if (this.addFrom.quasiDrivingModelArr) {
            this.addFrom.quasiDrivingModel = this.addFrom.quasiDrivingModelArr.join(',')
          }

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(this.addFrom))
          if (this.isBitian) {
            if (this.imgList.length == 5) {
              let arr = []
              for (let i = 0; i < this.imgList.length; i++) {
                if (this.imgList[i]) {
                  if (this.imgList[i] != 1) {
                    arr.push({ img: this.imgList[i], index: i })
                  }
                } else {
                  this.$alert('请上传证件信息', '系统提示')
                  return
                }
              }
              if (arr.length > 0) {
                for (let i = 0; i < arr.length; i++) {
                  let a = i
                  compressImage(arr[i].img.url, arr[i].img.raw, {
                    width: 1000
                  }).then(result => {
                    imgfile.append('file' + arr[a].index, result)// result即为压缩后的结果
                    if (a == arr.length - 1) {
                      if (this.isAdd) {
                        this.addJK(imgfile)
                      } else {
                        this.xiugaiJK(imgfile)
                      }
                    }
                  })
                }
              } else {
                if (this.isAdd) {
                  this.addJK(imgfile)
                } else {
                  this.xiugaiJK(imgfile)
                }
              }
            } else {
              this.$alert('请上传证件信息', '系统提示')
            }
          } else {
            if (this.isAdd) {
              this.addJK(imgfile)
            } else {
              this.xiugaiJK(imgfile)
            }
          }
        } else {
          return false
        }
      })
    },
    // 添加接口
    addJK (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDadd(data).then(res => {
        loading.close()
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.$emit('update:addDriverFlag', false)
        this.$emit('cDaddFn', res)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    imgPreview (data) {
      this.imgList[0] = data[0]
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    imgPreview1 (data) {
      this.imgList[1] = data[0]
    },
    handleRemove2 (data) {
      this.imgList[2] = null
    },
    imgPreview2 (data) {
      this.imgList[2] = data[0]
    },
    handleRemove3 (data) {
      this.imgList[3] = null
    },
    imgPreview3 (data) {
      this.imgList[3] = data[0]
    },
    handleRemove4 (data) {
      this.imgList[4] = null
    },
    imgPreview4 (data) {
      this.imgList[4] = data[0]
    },
    // 地区选中
    handleChange (value) {
      if (value) {
        this.addFrom.provinceCode = value[0].areaCode
        this.addFrom.cityCode = value[1].areaCode
        this.addFrom.areaCode = value[2].areaCode
        this.addFrom.provinceName = value[0].name
        this.addFrom.cityName = value[1].name
        this.addFrom.areaName = value[2].name
        this.$set(this.addFrom, 'xname', value[0].name)
      }
    },
    closeDialog () {
      this.$emit('update:addDriverFlag', false)
    }

  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>
.jiaoyan .inpBox /deep/.el-date-editor .el-input__inner{
  width: 150px;
}
</style>
